import { Button, Col, Container, Form } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { getLogsPromise, getMetricsPromise } from '../../services/api-calls';
import {
  METRICS_CONTACT_ID_NOT_FOUND_MESSAGE,
  LOGS_CONTACT_ID_NOT_FOUND_MESSAGE,
  LOGS_CONTACT_DATA_FIELD_MISSING,
} from '../../services/utils';

import GenericField from '../generic-field/GenericField';
import MetricsField from '../metrics-field/MetricsField';

const ContactIdForm = () => {
  const [isLogsLoading, setIsLogsLoading] = useState(false);
  const [isTranscriptLoading, setIsTranscriptLoading] = useState(false);
  const [validationError, setValidationError] = useState(null);
  const [transcriptError, setTranscriptError] = useState(null);
  const [isTreatTranscriptErrorAsInfo, setIsTreatTranscriptErrorAsInfo] = useState(false);
  const [isTreatTimerLogErrorAsInfo, setIsTreatTimberLogErrorAsInfo] = useState(false);
  const [logsError, setLogsError] = useState(null);
  const [contactId, setContactId] = useState('');
  const [metricsData, setMetricsData] = useState(null);
  const [logData, setLogData] = useState(null);

  useEffect(() => {
    if (logData) {
      setIsLogsLoading(false);
    }
    if (metricsData) {
      setIsTranscriptLoading(false);
    }
  }, [logData, metricsData]);

  const searchForContactId = event => {
    event.preventDefault();
    setValidationError();
    setTranscriptError();
    setLogsError();

    if (!contactId) {
      setValidationError('Contact ID is required.');
      return;
    }

    setIsLogsLoading(true);
    setIsTranscriptLoading(true);
    setMetricsData(null);
    setLogData(null);
    setIsTreatTranscriptErrorAsInfo(false);
    setIsTreatTimberLogErrorAsInfo(false);

    getMetricsPromise(contactId)
      .then(response => {
        setMetricsData(response);
        if (!response.data.messages || response.data.messages.length === 0) {
          setIsTranscriptLoading(false);
          setTranscriptError('No transcript found for this contactId');
        }
      })
      .catch(error => {
        const response = error?.response;
        if (response.status === 404) {
          setTranscriptError(METRICS_CONTACT_ID_NOT_FOUND_MESSAGE);
          setIsTreatTranscriptErrorAsInfo(true);
        } else {
          setTranscriptError(`Error while getting transcript: ${error?.response?.data}`);
        }
        setIsTranscriptLoading(false);
      });

    getLogsPromise(contactId)
      .then(response => {
        setIsLogsLoading(false);
        setLogData(response.data);
      })
      .catch(error => {
        const response = error?.response;
        if (response.status === 404) {
          setLogsError(`Error while getting logs: ` + LOGS_CONTACT_ID_NOT_FOUND_MESSAGE);
          setIsTreatTimberLogErrorAsInfo(true);
        } else if (response.status === 406) {
          setLogsError(`Error while getting logs: ` + LOGS_CONTACT_DATA_FIELD_MISSING);
          setIsTreatTimberLogErrorAsInfo(true);
        } else {
          setLogsError(`Error while getting logs: ${error}`);
        }
        setIsLogsLoading(false);
      });
  };

  return (
    <Container fluid className="bordered mt-2 mb-2 mr-4 ml-4 p-4 bg-white">
      <h5 className="mb-4">
        <b>Search for a Contact ID</b>
      </h5>
      <div className="alert alert-warning" role="alert">
        Transcript rendering is supported only for chat contacts created on or after Dec 7th, 2020. You can still query
        for logs though.
      </div>
      <div className="alert alert-warning" role="alert">
        tenantId and workflowId used for chat translations only available for chat contacts created on or after Jul
        30th, 2022.
      </div>
      <Form>
        <Col className="col-5">
          <Form.Control
            placeholder="Contact ID"
            value={contactId}
            onChange={e => setContactId(e.target.value)}
            onSubmit={searchForContactId}
          />
        </Col>
        <Col>
          <Button
            type="submit"
            className="mt-2"
            variant="primary"
            size="sm"
            onClick={searchForContactId}
            disabled={isLogsLoading || isTranscriptLoading}
          >
            Search
          </Button>
        </Col>
      </Form>
      {validationError && <h5 className="color-red">{validationError}</h5>}
      <MetricsField
        title="Transcript"
        data={metricsData?.data}
        error={transcriptError}
        isTreatErrorAsInfo={isTreatTranscriptErrorAsInfo}
        isLoading={isTranscriptLoading}
      />
      <br />
      <GenericField
        title="Log Entries"
        data={logData}
        error={logsError}
        isTreatErrorAsInfo={isTreatTimerLogErrorAsInfo}
        isLoading={isLogsLoading}
      />
    </Container>
  );
};

export default ContactIdForm;
